import { render } from "./Goods.vue?vue&type=template&id=822f983e&scoped=true"
import script from "./Goods.vue?vue&type=script&lang=js"
export * from "./Goods.vue?vue&type=script&lang=js"

import "./Goods.vue?vue&type=style&index=0&id=822f983e&scoped=true&lang=less"

import exportComponent from "D:\\perject\\suyuan\\eshop-vant4-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-822f983e"]])

export default __exports__